import { render } from "./AiTransactionsIndexPage.vue?vue&type=template&id=553080b2&scoped=true"
import script from "./AiTransactionsIndexPage.vue?vue&type=script&lang=js"
export * from "./AiTransactionsIndexPage.vue?vue&type=script&lang=js"

import "./AiTransactionsIndexPage.vue?vue&type=style&index=0&id=553080b2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553080b2"]])

export default __exports__